<div class="panel-info-bar-container row">
  @for (data of infoData; track data) {
    <div class="panel-info-bar-col" [ngClass]="data.columnWidth ? 'col-' + data.columnWidth : 'col'" title="{{ data.text }}">
      <div class="full-overflow-hidden">
        @if (data.icon) {
          <span [ngClass]="data.icon.class" [ngStyle]="{ 'color': data.icon.color, 'font-size': data.icon.size }"></span>
        }
        {{ data.text }}
      </div>
    </div>
  }
</div>